module.exports = __webpack_public_path__ + "static/media/lp_online.fcc2fdf0.svg";